import { atom } from "recoil";

// 扫码弹窗状态
export const ScanPopupState = atom<boolean>({
  key: 'ScanPopupState',
  default: false,
});